<template>
  <section class="bg-message-image">
    <div class="max-w-6xl mx-auto px-4 sm:px-6 relative font-message">
      <div class="relative">
        <!-- Section header -->
        <div class="max-w-xl mx-auto text-center pt-16 pb-12 md:pb-16">
          <p class="h2 text-3xl text-theme-900" data-aos="fade-up">あなたが健康になれば、社会も健康に。</p>
          <p class="h2 text-3xl text-theme-900 mt-12" data-aos="fade-up">あなたが笑顔になれば、社会も笑顔に。</p>
          <p class="h4 text-theme-900 font-bold mt-12" data-aos="fade-up">
            社会、つまりあなたの身の回りの人たち。<br />
            家族、友人、同僚、などなど……。<br />
            <br />
            そういった、あなたと関わりが強い人たちは、<br />あなたが健康で、笑顔で生きていてくれることを願っています。<br />
            <br />
            私は、あなたが健康で笑顔になるお手伝いをすることで、<br />社会全体を健康で笑顔にしていきたいと考えています。
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Message",
  components: {},
  data: function() {
    return {}
  },
}
</script>

<style scoped>
.bg-message-image {
  background-image: url("./../images/message-background.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
